document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll('.nav-links a[href^="#"]');

    links.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Define different offsets for mobile and desktop
                const desktopOffset = 300;
                const mobileOffset = 100; // Adjust this value for mobile

                // Check if it's mobile (you can adjust the breakpoint)
                const isMobile = window.innerWidth <= 768;
                const headerOffset = isMobile ? mobileOffset : desktopOffset;

                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
});
